export interface Filter {
  name: number
  value: number
}

interface Group {
  label: string
  colIds: number[]
  colorHint: string
}

export interface Properties {
  groups: Group[]
  median: undefined | number
  showXAxis: undefined | boolean
  dataType: undefined | number
  minYAxis: undefined | number
  maxYAxis: undefined | number
}

interface Header {
  value: string
  tooltip: string
}

interface ColumnHierarchy {
  hierarchyType: number
  branchName: null | string
  leafColumnId: null | number
  children: ColumnHierarchy[]
}

export interface Column {
  id: number
  name: string
  dataType: number
  properties: Record<string, unknown>
}

interface Cell {
  dataType: number
  value: string
  colspan: number
  properties: Record<string, unknown>
}

export enum DataType {
  Na = 0,
  Mix,
  String,
  Boolean,
  Double,
  Number0,
  Number1,
  Number2,
  Percent0,
  Percent1,
  Percent2,
  Bps0,
  Bps1,
  Bps2,
  es,
  YesNo,
  YesNoNa,
  YesNoSome,
  YesNoSomeNa,
  RecordingLiveBothNa,
  GrossNetBoth,
  MonthlyAnnualBoth,
  EstimateFinal,
  EachScenarioSingleEstimate,
}

interface Row {
  id: number
  name: string
  dataType: DataType
  cells: Cell[]
  nestedRows: Row[]
  properties: Record<string, unknown>
}

interface Caption {
  title: string
  titleTooltip: string
  body: string
  bodyIsHtml: boolean
}

interface Axis {
  label: string
  labelTooltip: string
  valueType: number
}

interface DrillDownInfo {
  type: number
  linkages: {
    [key: string]: {
      chartName: string
      additionalFilters?: {
        name: string
        value: string
      }[]
    }
  }
}

export interface IChart {
  id: string
  componentType: number
  name: string
  order: number
  tooltip: string
  filters: Filter[]
  children: any[] // Add proper type if you have a specific type for children
  chartType: number
  header: Header
  subHeader: Header
  columnHierarchy: ColumnHierarchy
  columns: Column[]
  rows: Row[]
  caption: Caption
  axisX: Axis
  axisY: Axis
  properties: Properties
  drillDownInfo: DrillDownInfo
}
